import React from 'react';
import { featuresData, ctaLink } from '../data/mock';
import { Search, Sparkles, BarChart3, Zap, Calendar, Link } from 'lucide-react';

const iconComponents = {
  Search,
  Sparkles,
  BarChart3,
  Zap,
  Calendar,
  Link
};

const FeaturesSection = () => {
  return (
    <section id="features" className="relative py-24 lg:py-32">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900/50 to-slate-950" />
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-teal-500/5 rounded-full blur-[120px]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 bg-teal-500/10 border border-teal-500/20 rounded-full text-sm font-medium text-teal-400 mb-6">
            Features
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Everything You Need to{' '}
            <span className="bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent">
              Dominate AI Search
            </span>
          </h2>
          <p className="text-lg text-slate-400">
            Publish content that gets cited and track your AI visibility across all major platforms.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuresData.map((feature, index) => {
            const Icon = iconComponents[feature.icon];
            return (
              <div
                key={index}
                className="group relative p-6 lg:p-8 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-teal-500/30 hover:bg-white/[0.05] transition-all duration-500"
              >
                {/* Glow Effect */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-b from-teal-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <div className="relative">
                  {/* Icon */}
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-teal-500/20 to-emerald-500/20 border border-teal-500/20 flex items-center justify-center mb-6 group-hover:border-teal-500/40 group-hover:scale-110 transition-all duration-300">
                    <Icon className="w-7 h-7 text-teal-400" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-teal-300 transition-colors duration-300">
                    {feature.title}
                  </h3>
                  <p className="text-slate-400 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <a
            href={ctaLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-teal-500/10 to-emerald-500/10 border border-teal-500/30 rounded-full text-teal-300 font-medium hover:bg-teal-500/20 hover:border-teal-500/50 transition-all duration-300"
          >
            Explore all features
            <span>→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
